import { axiosInstance } from '../common/api';

const quarterGoalEndPoint = '/company-quartergoals';

export const getAllQuarterGoals = ({ year, quarter }) => {
  const url = `${quarterGoalEndPoint}?year=${year}&quarter=${quarter}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const deleteQuarterGoal = (id) => {
  const url = `${quarterGoalEndPoint}/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const addQuarterGoal = (newQuarterGoal) => {
  const url = `${quarterGoalEndPoint}/add`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, newQuarterGoal)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const updateQuarterGoal = (id, updatedQuarterGoal) => {
  const url = `${quarterGoalEndPoint}/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, updatedQuarterGoal)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const togglePublishQuarterGoal = (id) => {
  const url = `${quarterGoalEndPoint}/${id}`;

  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
